export default __webpack_public_path__ + "static/media/png.faf7cad9.svg";